import React from 'react';
import { Input } from './styles';

interface Props {
  value: string;
  onChangeText: (text: string) => void;
}

const FormArea: React.FC<Props> = ({ onChangeText, value }) => {
  return <Input
    value={value}
    onChange={(e) => {
      onChangeText(e.currentTarget.value)
    }}
  >{value}</Input>;
}

export default FormArea;